import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/core/services/auth.service';
import { ZoneService } from 'src/app/core/services/zone.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

const MOIS_LABELS = ['Jan','Fév','Mar','Avr','Mai','Juin','Jul','Aoû','Sep','Oct','Nov','Déc'];

@Component({
  selector: 'app-parametres',
  templateUrl: './parametres.component.html',
  styleUrls: ['./parametres.component.scss']
})
export class ParametresComponent implements OnInit {
  activeTab: string = 'general';
  estAdministrateur = false;

  // ── Coûts opérationnels ─────────────────────────────────────────────────────
  zones: any[] = [];
  couts: any[] = [];
  chargementCouts = false;
  sauvegardeEnCours = false;

  formulaireCout: any = {
    zoneId: null,
    annee: new Date().getFullYear(),
    mois: new Date().getMonth() + 1,
    coutCarburant: 0,
    coutMainOeuvre: 0,
    coutEntretien: 0,
    coutCentreTri: 0,
    autresCharges: 0,
    nombreColisTraites: null
  };

  get moisOptions() {
    return MOIS_LABELS.map((l, i) => ({ val: i + 1, label: l }));
  }

  get anneeOptions() {
    const a = new Date().getFullYear();
    return [a - 2, a - 1, a, a + 1];
  }

  constructor(
    private authService: AuthService,
    private zoneService: ZoneService,
    private toast: ToastService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const role = (this.authService.obtenirUtilisateurCourant()?.role || '').toString().toUpperCase();
    this.estAdministrateur = role === 'ADMIN' || role === 'MANAGER' || role === 'COMPTABLE_GENERAL';
    if (!this.estAdministrateur) {
      this.activeTab = 'general';
    }
  }

  switchTab(tab: string): void {
    if (!this.estAdministrateur && (tab === 'notifications' || tab === 'entreprise' || tab === 'couts')) {
      this.activeTab = 'general';
      return;
    }
    this.activeTab = tab;
    if (tab === 'couts' && this.zones.length === 0) {
      this.zoneService.obtenirToutesLesZones().subscribe({
        next: (z: any[]) => { this.zones = z; this.chargerCouts(); },
        error: () => this.chargerCouts()
      });
    }
  }

  chargerCouts(): void {
    this.chargementCouts = true;
    this.http.get<any[]>(`${environment.apiurl}/couts-operationnels`).subscribe({
      next: (data) => { this.couts = Array.isArray(data) ? data : []; this.chargementCouts = false; },
      error: () => { this.couts = []; this.chargementCouts = false; }
    });
  }

  nomZone(id: number | null): string {
    if (!id) return 'Toutes zones';
    const z = this.zones.find(x => x.id === Number(id));
    return z ? z.nom : '—';
  }

  nomMois(m: number): string {
    return MOIS_LABELS[m - 1] ?? m.toString();
  }

  total(cout: any): number {
    return (cout.coutCarburant || 0) + (cout.coutMainOeuvre || 0) +
           (cout.coutEntretien || 0) + (cout.coutCentreTri || 0) + (cout.autresCharges || 0);
  }

  editerCout(cout: any): void {
    this.formulaireCout = {
      id: cout.id,
      zoneId: cout.zone?.id ?? null,
      annee: cout.annee,
      mois: cout.mois,
      coutCarburant: cout.coutCarburant || 0,
      coutMainOeuvre: cout.coutMainOeuvre || 0,
      coutEntretien: cout.coutEntretien || 0,
      coutCentreTri: cout.coutCentreTri || 0,
      autresCharges: cout.autresCharges || 0,
      nombreColisTraites: cout.nombreColisTraites || null
    };
  }

  reinitialiserFormulaire(): void {
    this.formulaireCout = {
      zoneId: null,
      annee: new Date().getFullYear(),
      mois: new Date().getMonth() + 1,
      coutCarburant: 0, coutMainOeuvre: 0, coutEntretien: 0,
      coutCentreTri: 0, autresCharges: 0, nombreColisTraites: null
    };
  }

  sauvegarderCout(): void {
    this.sauvegardeEnCours = true;
    this.http.post<any>(`${environment.apiurl}/couts-operationnels`, this.formulaireCout).subscribe({
      next: () => {
        this.toast.succes('Coûts enregistrés avec succès');
        this.reinitialiserFormulaire();
        this.chargerCouts();
        this.sauvegardeEnCours = false;
      },
      error: () => {
        this.toast.erreur('Erreur lors de l\'enregistrement');
        this.sauvegardeEnCours = false;
      }
    });
  }

  supprimerCout(id: number): void {
    if (!confirm('Supprimer cette entrée de coûts ?')) return;
    this.http.delete(`${environment.apiurl}/couts-operationnels/${id}`).subscribe({
      next: () => { this.toast.succes('Entrée supprimée'); this.chargerCouts(); },
      error: () => this.toast.erreur('Erreur lors de la suppression')
    });
  }

  onSubmit(): void {
    console.log('Paramètres sauvegardés');
  }
}
